import { installDesign } from '@routine-notes/ui/design';

// Single source of truth for Vuetify + theme + fonts + icon fonts + base CSS.
installDesign();
